import { Paper } from '@mui/material';
import styled from 'styled-components';

export const Container = styled(Paper)`
  && {
    margin: 16px;
    padding: 16px;
  }
`;
